import * as type from './signUpActionTypes';

// SETTERS

export const setCheckEmailExistsWaiting = (value) => ({
  type: type.SET_CHECK_EMAIL_EXISTS_WAITING,
  value,
});

export const setCheckEmailExistsSuccess = (value) => ({
  type: type.SET_CHECK_EMAIL_EXISTS_SUCCESS,
  value,
});

export const setCheckEmailExistsMessage = (message) => ({
  type: type.SET_CHECK_EMAIL_EXISTS_MESSAGE,
  message,
});

export const setSubscriptionWaiting = (value) => ({
  type: type.SET_SUBSCRIPTION_WAITING,
  value,
});

export const setSubscriptionSuccess = (value) => ({
  type: type.SET_SUBSCRIPTION_SUCCESS,
  value,
});

export const setSubscriptionMessage = (message) => ({
  type: type.SET_SUBSCRIPTION_MESSAGE,
  message,
});

export const setRates = (rates) => ({
  type: type.SET_RATES,
  rates,
});

export const setPlans = (plans) => ({
  type: type.SET_PLANS,
  plans,
});

export const setReferences = (references) => ({
  type: type.SET_REFERENCES,
  references,
});

export const setContentByWarfareQualsSignup = (quals) => ({
  type: type.SET_QUALS,
  quals,
});

export const setReferencesPmk = (referencesPmk) => ({
  type: type.SET_REFERENCES_PMK,
  referencesPmk,
});

export const setLoadingReferences = (value) => ({
  type: type.SET_LOADIG_REFERENCES,
  value,
});

export const setRatingExamQuestions = (ratingExamQuestions) => ({
  type: type.SET_RATING_EXAM_QUESTIONS,
  ratingExamQuestions,
});

export const setCycle = (cycle) => ({
  type: type.SET_CYCLE,
  cycle,
});

export const setCoupon = (coupon) => ({
  type: type.SET_COUPON,
  coupon,
});

export const setCounters = (
  chaptersWithoutQuestions,
  chaptersCount,
  questionsOccupational,
  questionsPmk,
  chaptersPmkCount,
  chaptersPmkWithoutQuestions,
) => ({
  type: type.SET_COUNTERS,
  chaptersWithoutQuestions,
  chaptersCount,
  questionsOccupational,
  questionsPmk,
  chaptersPmkCount,
  chaptersPmkWithoutQuestions,
});

export const resetComponent = () => ({
  type: type.RESET_COMPONENT,
});

// TO SAGAS
export const loadAllPublicRates = () => ({
  type: type.GET_ALL_PUBLIC_RATES,
});

export const loadReferences = (rateId, rank, dutyState) => ({
  type: type.GET_REFERENCES,
  rateId,
  rank,
  dutyState,
});

export const loadQualsData = () => ({
  type: type.GET_QUALS_DATA,
});

export const loadPlans = () => ({
  type: type.GET_PLANS,
});

export const checkEmailExists = (email) => ({
  type: type.CHECK_EMAIL_EXISTS,
  email,
});

export const checkCoupon = (coupon, planId, isTrialUser, userId = 0) => ({
  type: type.CHECK_COUPON,
  coupon,
  planId,
  isTrialUser,
  userId,
});

export const makeSubscription = (data) => ({
  type: type.MAKE_SUBSCRIPTION,
  data,
});
